// src/pages/WishlistScreen.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { useApp } from '../lib/AppContext';
import { t } from '../lib/i18n';

export default function WishlistScreen() {
  const { lang, profile, addToCart, fmt } = useApp();
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!profile?.wishlist?.length) return;
    supabase.from('products').select('*').in('id', profile.wishlist)
      .then(({ data }) => setProducts(data || []));
  }, [profile?.wishlist]);

  if (!profile?.wishlist?.length) return (
    <div style={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', minHeight:'50vh' }}>
      <div style={{ fontSize:'3rem', opacity:.15, marginBottom:12 }}>❤️</div>
      <p style={{ color:'#555', fontFamily:"'Barlow Condensed',sans-serif", letterSpacing:'.1em', textTransform:'uppercase', fontSize:'.9rem' }}>{t('wishlist', lang)} empty</p>
    </div>
  );

  return (
    <div style={{ maxWidth: 900, margin:'0 auto', padding:'32px 24px' }}>
      <h2 style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:'1.8rem', letterSpacing:'.05em', marginBottom:20 }}>{t('wishlist', lang)}</h2>
      <div className="prod-grid">
        {products.map(p => (
          <div key={p.id} className="prod-card" onClick={() => navigate(`/product/${p.id}`)}>
            <div className="prod-card-img"><span style={{ opacity:.2 }}>🌿</span></div>
            <div className="prod-card-body">
              <div className="prod-card-name">{p.name?.[lang] || p.name?.en}</div>
              <div className="prod-card-foot">
                <span className="prod-price">{fmt(p.price_eur)}</span>
                <button className="prod-add-btn" onClick={e => { e.stopPropagation(); addToCart(p); }}>+</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
